$(function(){

    var $adTmp = $('#advertising-main');

    if ($adTmp.length) {

        var heightPage = $(window).height(); // Высота окна
        var coMain = $adTmp.offset(); // Координаты $adTmp
        var toMain = coMain.top; // расстояние до $adTmp
        var coBottom = $('.footer').offset(); // Координаты footer
        var toBottom = coBottom.top; // расстояние до footer
        var heightFooter = $('.footer').outerHeight();
        var criticalScroll = toBottom - (heightFooter * 2 + heightPage);

        $(window).scroll(function() {

            var top = $(document).scrollTop();

            if (DESKTOP) {

                if (criticalScroll < top) {
                    $('.js-left-menu').addClass('left-menu-fixed--bottom');
                } else

                {
                    $('.js-left-menu').removeClass('left-menu-fixed--bottom');
                }


            } else {



                if (criticalScroll < top) {
                    $('.button-to-bottom').fadeOut();
                }

                // for mobile

                else

                {
                    $('.button-to-bottom').fadeIn();
                }

            }


        });


    }

    var tog = $('.js-left-menu__list'),
        tech = $('.js-technical-data__list');



    tog.hide();
    tech.hide();

    $('.js-left-menu__open').on('click', function(){
        tog.slideToggle();
        $(this).find('.js-left-menu__arrow i').toggleClass('js-turn-arrow');

        return false;
    });

    $('.js-technical-data__open').on('click', function(){
        tech.slideToggle();
        $(this).find('.js-technical-data__arrow i').toggleClass('js-turn-arrow');

        return false;
    });

    $(window).scroll(function() {
        var top = $(document).scrollTop();

        if (top > toMain) $('.js-left-menu').addClass('left-menu-fixed'); //200 - это значение высоты прокрутки страницы для добавления класс
        else $('.js-left-menu').removeClass('left-menu-fixed');
        tog.hide();



    });


    // $('a[href^="#"]').click(function(){
    //     $('body').animate({scrollTop: $(this).offset().top - 50}, 2000);
    //     return false;
    // });
});